<div class="pathways-panel-container">
  <dls-tabs>
    <a *ngFor="let tab of tabs" (click)="onTabChanged(tab)" [ngClass]="{'pt-selected':tab === selectedTab}">
      <span>{{tab | translate}}</span>
    </a>
  </dls-tabs>

  <div class="pathways-left-side" *ngIf="isSelected('Pathways Selection')">
    <div class="headline" [ngClass]="selectActive ? 'selectable' : 'notSelectable'">Pathway selections</div>

    <ispm-selectable-item class="ispm-selectable-item"
                          *ngIf="selectActive"
                          [item$]="selectableItem$"
                          (selectedItemEmitter)="onSelect($event)">
    </ispm-selectable-item>

    <ispm-generic-list
      [items$]="items$"
      [maxHeight]="'57vh'"
      (selectedItemEmitter)="onSelect($event)">
    </ispm-generic-list>

    <section *ngIf="resetButtonDisplayed" class="reset-button-container">
      <gen-button class='reset-button'
                  [disabled]="resetDisabled"
                  [type]="'secondary'"
                  [text]="'Reset'"
                  (click)="reset()">
      </gen-button>
    </section>
  </div>

  <div class="pathways-left-side" *ngIf="isSelected('Clinical Information')">
    <dls-accordion>
      <ng-container *ngFor="let form of (forms$ | async)">
        <dls-expander  [header]="form.formName">
          <gen-dynamic-form  class="info-dynamic-form"
                             [formName]="form.formId"
                             [formVertical]="false"
                             [updateOnBlur]="false"
                             [editMode]="false"
                             [requiredMessage]="''"
                             [mode]="'text'"
                             [emitFormChangeEvenIfInvalid] = true>
          </gen-dynamic-form>
        </dls-expander>
      </ng-container>
    </dls-accordion>
  </div>
</div>
